// extracted by mini-css-extract-plugin
export default {"form":"CreateInvoice_form__EZVbd","formService":"CreateInvoice_formService__JTvqB","formRow":"CreateInvoice_formRow__MLJxK","removeBtn":"CreateInvoice_removeBtn__DvDLn"};